// MessagePanelBottom.js
import { connect } from 'react-redux';
import MessagePanelBottom from '../component/MessagePanelBottom.jsx';

import getMessageData from '../selector/getMessageData.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';

import login from '../action/login.js';
import sendChatStart from '../action/sendChatStart.js';
import setGiftPanel from '../action/setGiftPanel.js';
import setMessageExpanded from '../action/setMessageExpanded.js';
import sendUnlockMessage from '../action/sendUnlockMessage.js';

import getMessageUnlockPrice from '../selector/getMessageUnlockPrice.js';
import getUnlockButtonStatus from '../selector/getUnlockButtonStatus.js';

const mapStateToProps = (state, { id }) => {
  const userId = getMessageData(state, id, 'senderId');
  const meId = getMeData(state, 'id');
  const listType = getOperationData(state, ['usingList', 'messages'], 'type');
  const unlockPrice = getMessageUnlockPrice(state, id);

  return {
    isMe: meId === userId,
    userId,
    unlockPrice,
    type: getMessageData(state, id, 'type'),
    username: getUserData(state, userId, 'username'),
    isAuthed: !!meId,
    isFree: unlockPrice === 0,
    isFreeZone: listType === 'freeZone',
    isSending: getOperationData(state, ['message', id], 'isSending'),
    isUnlocked: getMessageData(state, id, 'canViewMedia'),
    unlockButtonStatus: getUnlockButtonStatus(state, id),
    ctaUrlData: getMessageData(state, id, 'ctaUrlData'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    sendChatStart: userId => dispatch(sendChatStart({ userId })),
    onGiftClick: userId => {
      dispatch(sendChatStart({ userId }));
      dispatch(setGiftPanel({ isOpen: true }));
    },
    sendUnlockMessage: ({
      id,
      shouldCheckDrm,
      shouldOpenMessagePackUpsellingModal,
      drmFeatureName,
    }) =>
      dispatch(
        sendUnlockMessage({
          id,
          shouldCheckDrm,
          shouldOpenMessagePackUpsellingModal,
          drmFeatureName,
        })
      ),
    setExpanded: ({ expandedField, messageId }) =>
      dispatch(setMessageExpanded({ expandedField, messageId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagePanelBottom);
